const postAcceptRequestPayload = (payload) => {
  return { helpRequestId: payload?.helpRequestId };
};

export default postAcceptRequestPayload;
